import React, { PropsWithChildren, useMemo } from "react"

type ContextProps = {
  facets: any
  product: any
  addresses: any
}

export const LocaleContext = React.createContext<ContextProps | undefined>(undefined);

export const LocaleProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const getJsonByQuery = (query: string) => {
    const script = document.querySelector(query)

    if (!script) return null

    try {
      const json = JSON.parse(script.innerHTML)
      return json
    } catch (e) {
      console.error("Error parsing locale JSON")
      return null
    }
  }

  const facets = useMemo(() => {
    return getJsonByQuery("[data-locale-facets]")
  }, [getJsonByQuery])

  const product = useMemo(() => {
    return getJsonByQuery("[data-locale-product]")
  }, [getJsonByQuery])

  const addresses = useMemo(() => {
    return getJsonByQuery("[data-locale-addresses]")
  }, [getJsonByQuery])

  const contextValue = useMemo<ContextProps>(
    () => ({
      facets,
      product,
      addresses
    }),
    [facets, product, addresses]
  )

  return <LocaleContext.Provider value={contextValue}>{children}</LocaleContext.Provider>
}

export const useLocaleContext = (): ContextProps => ({ ...React.useContext(LocaleContext) } as ContextProps)